import React from "react";

import { useTerms } from "./useTerms.tsx";
import TermsUI from "./Terms.ui.tsx";
import { TermsExternalProps } from "./Terms.types.tsx";

const Terms: React.FC<TermsExternalProps> = ({ onBackToLogin }) => {
  const termsState = useTerms();

  return <TermsUI {...termsState} onBackToLogin={onBackToLogin} />;
};

export default Terms;
